import { defineMessages } from "react-intl";

export const shopAndGoMessages = defineMessages({
    filterPresetsAll: {
      defaultMessage: "All Shop and Go Orders",
      id: "W1k1hB",
    },
  });
  